// Cache utility for PWA - clears cache after data operations

export const clearAppCache = async () => {
  try {
    // Clear all browser caches
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map(name => caches.delete(name)));
      console.log('[Cache] Cleared all caches');
    }
    
    // Clear localStorage cache keys (if any)
    const cacheKeys = Object.keys(localStorage).filter(key => 
      key.startsWith('cache_') || key.startsWith('data_')
    );
    cacheKeys.forEach(key => localStorage.removeItem(key));
    
    // Tell service worker to clear cache
    if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({ type: 'CLEAR_CACHE' });
    }
    
    // Unregister and re-register service worker for fresh start
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (const registration of registrations) {
        await registration.update();
      }
    }
    
  } catch (error) {
    console.debug('Cache clear error:', error.message);
  }
};

// Force refresh all data by clearing cache and reloading
export const forceRefresh = async () => {
  await clearAppCache();
  window.location.reload(true);
};

// Call this after any data mutation (create, update, delete)
export const onDataMutation = async () => {
  await clearAppCache();
};

export default clearAppCache;
